/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CertificationSkillTranslation } from './';
import {
    CertificationSkillTranslationFromJSON,
    CertificationSkillTranslationFromJSONTyped,
    CertificationSkillTranslationToJSON,
} from './';

/**
 * 
 * @export
 * @interface CertificationTranslation
 */
export interface CertificationTranslation {
    /**
     * 
     * @type {string}
     * @memberof CertificationTranslation
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CertificationTranslation
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CertificationTranslation
     */
    organization?: string;
    /**
     * 
     * @type {Array<CertificationSkillTranslation>}
     * @memberof CertificationTranslation
     */
    skills?: Array<CertificationSkillTranslation>;
}

/**
 * Check if a given object implements the CertificationTranslation interface.
 */
export function instanceOfCertificationTranslation(value: object): value is CertificationTranslation {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CertificationTranslationFromJSON(json: any): CertificationTranslation {
    return CertificationTranslationFromJSONTyped(json, false);
}

export function CertificationTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CertificationTranslation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'organization': json['organization'] == null ? undefined : json['organization'],
        'skills': json['skills'] == null ? undefined : ((json['skills'] as Array<any>).map(CertificationSkillTranslationFromJSON)),
    };
}

export function CertificationTranslationToJSON(value?: CertificationTranslation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'title': value['title'],
        'organization': value['organization'],
        'skills': value['skills'] == null ? undefined : ((value['skills'] as Array<any>).map((v) => CertificationSkillTranslationToJSON(v))),
    };
}

